// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"362":"b7f579fb9352cd1b1bbd","721":"ce0570ded340869df4c2"}[chunkId] + ".js";
};